const Columns = () => {
  return [
    {
      title: '',
      dataIndex: 'sow',
    },
    {
      title: 'Data Level 1',
      dataIndex: 'level1',
      editable: true,
      width: '10%',
      align: 'right',
      render: (text, record) => ['Data Management', 'Project Management', 'Client Service'].includes(record.sow)  ? `${text} %` : text,
    },
    {
      title: 'Data Level 2',
      dataIndex: 'level2',
      editable: true,
      width: '10%',
      align: 'right',
      render: (text, record) => ['Data Management', 'Project Management', 'Client Service'].includes(record.sow)  ? `${text} %` : text,
    },
    {
      title: 'Data Level 3',
      dataIndex: 'level3',
      editable: true,
      width: '10%',
      align: 'right',
      render: (text, record) => ['Data Management', 'Project Management', 'Client Service'].includes(record.sow)  ? `${text} %` : text,
    },
    {
      title: 'Department',
      dataIndex: 'department',
      align: 'center',
    },
    {
      title: 'Position',
      dataIndex: 'position',
      align: 'center',
    },
  ];
};

export default Columns;
